export default "__VITE_ASSET__bb3a129a__"